export const store_admin_route = [
    // {
    //     name: "store_admin",
    //     url: "/store-admin",
    //     template: '<div ui-view></div>',
    // },
    // {
    //     url: '/shippment',
    //     name: 'store_admin.shippment',
    //     component: 'storeAdminShippment'
    // }
];




// WEBPACK FOOTER //
// ./src/store-modules/app/route/store-admin/store-admin-route.ts